import * as swcHelpers from '@swc/helpers';
import { optionalKey } from '@grandvisionhq/utils';
import { AddressLineFormat } from '../../../models/checkout-settings.js';

const mapDataToFormValues = (data, addressLookup)=>{
    const { city , postalCode , province , streetNumber  } = data;
    let { streetName  } = data;
    if ((addressLookup === null || addressLookup === void 0 ? void 0 : addressLookup.shouldCombineAddress) && streetNumber) {
        var ref;
        var _addressLineFormat;
        addressLookup.addressLineFormat = (_addressLineFormat = addressLookup.addressLineFormat) !== null && _addressLineFormat !== void 0 ? _addressLineFormat : AddressLineFormat.streetName_streetNumber;
        const addressKeysSequence = (ref = addressLookup.addressLineFormat) === null || ref === void 0 ? void 0 : ref.split('_');
        streetName = '';
        addressKeysSequence === null || addressKeysSequence === void 0 ? void 0 : addressKeysSequence.forEach((key)=>{
            streetName += `${data[key]} `;
        });
    }
    var ref1;
    return swcHelpers.objectSpread({
        streetName: (ref1 = streetName === null || streetName === void 0 ? void 0 : streetName.trim()) !== null && ref1 !== void 0 ? ref1 : ''
    }, optionalKey('streetNumber', streetNumber), optionalKey('city', city), optionalKey('postalCode', postalCode), optionalKey('region', province));
};

export { mapDataToFormValues };
//# sourceMappingURL=map-data-to-form-values.js.map
